// @flow

import { serializePromises } from 'clark-utils';
import { getResourceRequest, getResourceSuccess, getResourceFailure } from 'actions/resources';
import { addApplicationLoader, removeApplicationLoader } from 'actions/application';
import { type ResourceNameType } from 'types/resources';
import { type DispatchType, type GetStateType, type ApiType } from 'types/redux';

export type PageQueryObjectType = {
  pageNumber: number,
  pageSize: number,
};

export type ScopedResourceType = { resource: ResourceNameType, id: string };

export type GetResourceArgsType = {
  resource: ResourceNameType,
  resourceId?: string,
  scopedToResource?: ScopedResourceType,
  includes?: string[],
  isTutor: boolean,
  page?: PageQueryObjectType,
  filterString?: string,
  sort?: string,
  lazyLoad?: boolean,
};

// eslint-disable-next-line import/prefer-default-export
export const getResource = ({
  resource,
  resourceId,
  scopedToResource,
  includes,
  isTutor,
  page,
  filterString,
  sort,
  lazyLoad,
}: GetResourceArgsType) => async (
  dispatch: DispatchType,
  getState: GetStateType,
  api: ApiType,
): Promise<any> => {
  const path = api.calculateRequestPath({
    resource,
    resourceId,
    scopedToResource,
    includes,
    isTutor,
    page,
    requestType: 'GET',
    filterString,
    sort,
  });
  dispatch(addApplicationLoader());
  dispatch(getResourceRequest());
  let response;
  try {
    response = await api.get(path);
    api.checkStatus(response);
    dispatch(getResourceSuccess(response));
    if (page && lazyLoad) {
      const queryString = path.split(resource)[1];
      const { pageCount } = response.meta[resource][queryString].meta;
      const count = pageCount === 0 ? pageCount : pageCount - 1;
      const funcs = [...Array(count)].map((_, i) => () =>
        dispatch(
          getResource({
            resource,
            resourceId,
            scopedToResource,
            includes,
            isTutor,
            filterString,
            sort,
            page: { ...page, pageNumber: 2 + i },
          }),
        ),
      );
      serializePromises(funcs);
    }
  } catch (error) {
    dispatch(getResourceFailure(error));
  }
  dispatch(removeApplicationLoader());
  return response;
};



// WEBPACK FOOTER //
// ./src/actions/resources/thunks.js